export type GetCenterWithOffsetProps = {
  map: google.maps.Map;
  lat: number;
  lng: number;
  xPixelOffset: number;
  yPixelOffset: number;
};

export const getCenterWithOffset = ({
  map,
  lat,
  lng,
  xPixelOffset,
  yPixelOffset,
}: GetCenterWithOffsetProps) => {
  const scale = 2 ** (map.getZoom() ?? 0);

  const worldCoordinateCenter = map.getProjection()?.fromLatLngToPoint({
    lat,
    lng,
  });

  const pixelOffset = new google.maps.Point(
    xPixelOffset / scale || 0,
    yPixelOffset / scale || 0
  );

  if (worldCoordinateCenter) {
    const worldCoordinateNewCenter = new google.maps.Point(
      worldCoordinateCenter.x - pixelOffset.x,
      worldCoordinateCenter.y + pixelOffset.y
    );

    const newCenter = map
      .getProjection()
      ?.fromPointToLatLng(worldCoordinateNewCenter);

    return newCenter;
  }

  return null;
};
